export function startOAuth(provider, userId) {

  console.log("provider =", provider)

  if (provider === "quickbooks") {
    // QuickBooks OAuth 2.0 Authorization URL
    //const clientId = "ABhOC3XzziVS4UvxKmSdgoYSOgwMnt78PfO6W3BAQesTLW7CVE"; // SANDBOX
    const clientId = "ABNlUmfs846loPwcUevwigItFhH6nCXbgb1wWdTLpD7nEK6tOX"; // PROD
    const redirectUri = encodeURIComponent("https://report.beesql.com/callbackqb.html");
    const scope = encodeURIComponent(
      "com.intuit.quickbooks.accounting openid profile email phone address"
    );
    const STATE = `uid:${encodeURIComponent(String(userId || ""))}`;

    const authUrl = `https://appcenter.intuit.com/connect/oauth2` +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scope}` +
      `&state=${STATE}`;

    window.open(
      authUrl,
      "quickbooks-oauth",
      "width=900,height=800,left=" +
        (window.screenX + (window.outerWidth - 900) / 2) +
        ",top=" +
        (window.screenY + (window.outerHeight - 800) / 2)
    );
    return;
  }


  if (provider === "xero") {
    const clientId = "503F38FA280A43D88FE6BDD601004528"; // zamijeni
    const redirectUri = encodeURIComponent("https://report.beesql.com/callbackxe.html"); // zamijeni
    const scope = encodeURIComponent(
      "offline_access openid profile email accounting.transactions accounting.settings"
    );
    const STATE = `uid:${encodeURIComponent(String(userId || ""))}`;

    const authUrl = `https://login.xero.com/identity/connect/authorize` +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scope}` +
      `&state=${STATE}`;

    window.open(
      authUrl,
      "xero-oauth",
      "width=900,height=800,left=" +
        (window.screenX + (window.outerWidth - 900) / 2) +
        ",top=" +
        (window.screenY + (window.outerHeight - 800) / 2)
    );
    return;
  }


  if (provider === "sage") {
    const clientId = "1841c239-1b0f-4442-bd56-9a61702d3048/67173fce-46e9-4f24-9a3a-87e4e6f2c34c"; 
    const redirectUri = "https://report.beesql.com/callbacksa.html"; // zamijeni
    const scope = encodeURIComponent(
      "full_access"
    );
    const STATE = `uid:${encodeURIComponent(String(userId || ""))}`;

    const authUrl = `https://www.sageone.com/oauth2/auth/central?filter=apiv3.1` +
      `&response_type=code` +
      `&client_id=${clientId}` +
      `&scope=${scope}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code`+
      `&state=${STATE}`;

    console.log(authUrl);

    window.open(
      authUrl,
      "sage-oauth",
      "width=900,height=800,left=" +
        (window.screenX + (window.outerWidth - 900) / 2) +
        ",top=" +
        (window.screenY + (window.outerHeight - 800) / 2)
    );
    return;
  }


  if (provider === "D365BC") {
    const STATE = `uid:${encodeURIComponent(String(userId || ""))}`;

const clientId = "447940a4-eac7-4660-ada3-37df64b25e7a";
const redirectUri = "https://report.beesql.com/callbackd365BC.html";
 

const scope = "https://api.businesscentral.dynamics.com/Financials.ReadWrite.All offline_access openid profile";

const authUrl =
  "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize" +
  `?client_id=${encodeURIComponent(clientId)}` +
  `&scope=${encodeURIComponent(scope)}` +
  `&redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&response_mode=query` +
  `&response_type=code` +
  `&prompt=consent` +
  `&state=${STATE}`;

console.log(authUrl);

window.location.href = authUrl;


    window.open(
      authUrl,
      "d365bc-oauth",
      "width=900,height=800,left=" +
        (window.screenX + (window.outerWidth - 900) / 2) +
        ",top=" +
        (window.screenY + (window.outerHeight - 800) / 2)
    );
    return;
  }

  const popup = window.open(
    "",
    "hello-popup",
    "width=400,height=300,left=" +
      (window.screenX + (window.outerWidth - 400) / 2) +
      ",top=" +
      (window.screenY + (window.outerHeight - 300) / 2)
  );

  if (popup) {
    popup.document.write(`
      <html>
        <head>
          <title>${provider} Connection</title>
          <style>
            body {
              font-family: sans-serif;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100vh;
              margin: 0;
            }
            h1 {
              color: #0070ba;
            }
          </style>
        </head>
        <body>
          <h1>${provider} Connected!</h1>
        </body>
      </html>
    `);
  } else {
    alert("Popup blocked! Please allow popups for this site.");
  }
}
